<template>
  <layout title="Users">
    <div class="row">
      <div class="col-10">
        <h2 class="page-heading">
          <inertia-link
            class="previous-path-header"
            :href="route('users.index')"
          >
            Users
          </inertia-link>
          / Create
        </h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
          <div class="card-body col-md-8">
            <form @submit.prevent="create">
              <h4>Personal Details</h4>
              <hr />

              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">
                  First Name
                </label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    id="first_name"
                    v-model="form.first_name"
                  />
                  <div
                    v-if="errors && errors.first_name"
                    class="d-block invalid-feedback"
                  >
                    {{ errors.first_name }}
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">
                  Last Name
                </label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    id="last_name"
                    v-model="form.last_name"
                  />
                  <div
                    v-if="errors && errors.last_name"
                    class="d-block invalid-feedback"
                  >
                    {{ errors.last_name }}
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">Email</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    id="email"
                    v-model="form.email"
                  />
                  <div
                    v-if="errors && errors.email"
                    class="d-block invalid-feedback"
                  >
                    {{ errors.email }}
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">
                  Student ID
                </label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    id="student_reg_id"
                    v-model="form.student_reg_id"
                  />
                  <div
                    v-if="errors && errors.student_reg_id"
                    class="d-block invalid-feedback"
                  >
                    {{ errors.student_reg_id }}
                  </div>
                </div>
              </div>

              <h4 class="mt-5">User Account</h4>
              <hr />
              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">
                  Username
                </label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    id="last_name"
                    v-model="form.username"
                  />
                  <div
                    v-if="errors && errors.username"
                    class="d-block invalid-feedback"
                  >
                    {{ errors.username }}
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">
                  Password
                </label>
                <div class="col-sm-10">
                  <input
                    type="password"
                    class="form-control"
                    id="password"
                    v-model="form.password"
                  />
                  <div
                    v-if="errors && errors.password"
                    class="d-block invalid-feedback"
                  >
                    {{ errors.password }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">
                  Confirm Password
                </label>
                <div class="col-sm-10">
                  <input
                    type="password"
                    class="form-control"
                    id="password_confirmation"
                    v-model="form.password_confirmation"
                  />
                  <div
                    v-if="errors && errors.password_confirmation"
                    class="d-block invalid-feedback"
                  >
                    {{ errors.password_confirmation }}
                  </div>
                </div>
              </div>

              <h4 class="mt-5">Roles and Permission</h4>
              <hr />

              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">Tenant</label>
                <div class="col-sm-10">
                  <select class="form-control" v-model="form.tenant_id">
                    <option
                      v-for="tenant in tenants"
                      :key="tenant.id"
                      :value="tenant.id"
                      :selected="tenant.id == form.tenant_id"
                    >
                      {{ tenant.name }}
                    </option>
                  </select>
                  <div
                    v-if="errors && errors.tenant_id"
                    class="d-block invalid-feedback"
                  >
                    {{ errors.tenant_id }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">
                  Role(s)
                </label>
                <div class="col-sm-10">
                  <select multiple class="form-control" v-model="form.roles">
                    <option
                      v-for="role in roles"
                      :key="role.id"
                      :value="role.id"
                      :selected="role.id == form.roles"
                    >
                      {{ role.name }}
                    </option>
                  </select>
                  <div
                    v-if="errors && errors.roles"
                    class="d-block invalid-feedback"
                  >
                    {{ errors.roles }}
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-sm-12">
                  <button type="submit" class="btn btn-primary float-right">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";

export default {
  layout: AppLayout,
  props: {
    errors: Object,
    tenants: Object,
    roles: Object,
  },
  data() {
    return {
      form: {
        tenant_id: this.tenants.length ? this.tenants[0].id : "",
        roles: [],
        first_name: "",
        last_name: "",
        student_reg_id: "",
        username: "",
        email: "",
        password: "",
        password_confirmation: "",
      },
    };
  },
  methods: {
    create() {
      this.$inertia.post(route("users.store"), this.form);
    },
  },
};
</script>
